export const normalizeAssayId = (value = '') => String(value || '').trim();

export const buildBiologiaMolecularDetailPath = (assayId = '') => {
  const normalizedId = normalizeAssayId(assayId);

  if (!normalizedId) {
    return '/biologia-molecular';
  }

  return `/biologia-molecular/ensayo/${encodeURIComponent(normalizedId)}`;
};

export const buildBiologiaMolecularClosurePath = (assayId = '') => {
  const normalizedId = normalizeAssayId(assayId);

  if (!normalizedId) {
    return '/biologia-molecular/dashboard';
  }

  return `/biologia-molecular/ensayo/${encodeURIComponent(normalizedId)}/cierre`;
};
